import NavHeader from '../shared/Nav-Header';
import styles from './learn-teach.module.css';
import axios from 'axios';
import Notification from '../../shared/Notification';
import { useEffect, useState, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const GuestLearnTeach = () => {
        
    const [searchParams] = useSearchParams();
    const [searchParamsValue, setSearchParamsValue] = useState(searchParams.get("edit") || false);
    // console.log('Search Params Value:', searchParamsValue);
    const [isEditing, setIsEditing] = useState(searchParams.get("edit") ||false);
    const [notification, setNotification] = useState('');
    const [lnt, setLnt] = useState({
        toLearn: '',
        toTeach: '',
        language: '',
    });
    const navigate = useNavigate();
    const languages = [
        'Hindi', 'English', 'Afrikaans','Amharic', 'Arabic', 'Assamese', 'Bengali','Bhojpuri', 'Bodo', 'Burmese', 'Chhattisgarhi', 'Chinese', 'Czech', 'Danish', 'Dogri', 'Dutch', 'English', 'Filipino', 'Finnish', 'French', 'German', 'Greek', 'Gujarati','Haryanvi', 'Hausa', 'Hebrew', 'Hindi', 'Hungarian', 'Indonesian', 'Italian', 'Japanese', 'Javanese', 'Kannada', 'Kashmiri', 'Konkani', 'Korean', 'Maithili', 'Malayalam', 'Mandarin', 'Manipuri', 'Marathi', 'Nepali', 'Norwegian', 'Odia', 'Pashto','Persian', 'Polish', 'Portuguese', 'Punjabi','Rajasthani', 'Romanian', 'Russian', 'Santali', 'Sindhi', 'Spanish', 'Swahili', 'Swedish', 'Tamil', 'Telugu', 'Thai', 'Turkish', 'Ukrainian', 'Urdu', 'Vietnamese', 'Yoruba', 'Zulu', 'Other'
    ];
    const [sentOffers, setSentOffers] = useState([]);
    const [receivedOffers, setReceivedOffers] = useState([]);
    const token = useMemo(() => localStorage.getItem('token'), []);
    const [acceptedOffers, setAcceptedOffers] = useState([]);
    const {userId} = useAuth();

    useEffect(() => {

        const fetchLearnTeachInfo = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'Please login first');
                    navigate('/signup');
                    return;
                }
                const response = await axios.get('/api/guest/learn-teach/get-learn-teach');
                // console.log('Learn/Teach data fetched:', response.data);
                setLnt(response.data);
            } catch (error) {
                // console.error('Error fetching profile:', error);
                localStorage.removeItem('token'); // Optionally remove invalid token
                localStorage.setItem('notification', 'Session expired, please login again');
            }
        };

        fetchLearnTeachInfo();
    }, [navigate]);

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const response = await axios.get('/api/guest/learn-teach/offers');
                if(response.data){
                    setSentOffers(response.data.sentOffers);
                    setReceivedOffers(response.data.receivedOffers);
                    setAcceptedOffers(response.data.accepted);
                }
                // console.log('Offers data fetched:', response.data);
            } catch (error) {
                // console.error('Error fetching offers:', error.message);
            }
        };

        fetchOffers();
    }, []);

    const handleOfferClick1 = (offerId, profileId) => async () => {
            // console.log('OfferView params:', offerId, profileId);
        navigate(`/guest/offer/view/${offerId}?profileId=${profileId}&profileType=sender`);
    }
    const handleOfferClick2 = (offerId, profileId) => async () => {
            // console.log('OfferView params:', offerId, profileId);
        navigate(`/guest/offer/view/${offerId}?profileId=${profileId}&profileType=receiver`);
    }
    const handleOfferClick = (offer) => async () => {
        // console.log(offer.receiverId);
        // console.log(offer.senderId);
        // console.log('UserId:', userId);
            const profileId = offer.receiverId === userId
                ? offer.senderId // receiverId populated hai, toh user sender hai
                : offer.receiverId; 
            // console.log('OfferView params3:',offer._id , profileId);
        navigate(`/guest/offer/view/${offer._id}?profileId=${profileId}&profileType=connected`);
    }

    const handleChange = (e) => {
        setLnt({ ...lnt, [e.target.name]: e.target.value });
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };
    const handleSaveAndSearch = async () => {
        try {
            await axios.put('/api/guest/learn-teach/update-learn-teach', lnt);
            setIsEditing(false);
            handleSearch();
        } catch (error) {
            handleSearch();
            // console.error('Error updating Learn/Teach information:', error);
        }
    };

    const handleSearch = () => {
        const queryParams = new URLSearchParams({
            toLearn: lnt.toLearn,
            toTeach: lnt.toTeach,
            language: lnt.language,
        }).toString();
        navigate(`/guest/lnt/search?${queryParams}`);
    };
     const handleSaveClick = async () => {

        try {
            await axios.put('/api/guest/learn-teach/update-learn-teach', lnt, {
                // headers: {
                //     Authorization: `Bearer ${token}`
                // },
            });
            setNotification('Learn/Teach information updated successfully');
            setIsEditing(false);
        } catch (error) {
            setNotification('Error updating Learn/Teach information');
            // console.error('Error updating Learn/Teach information:', error);
        }
    };

    const handleCancelClick = () => {
        setIsEditing(false);
    };

  return (
    <div>
        <NavHeader/>
        {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}                
        <div className={styles.lntContainer}>
            <h4>LearnTeach</h4>
                <div className={styles.profileInfo}>
                    <label>To Learn:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="toLearn"
                            value={lnt.toLearn}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{lnt.toLearn}</p>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>To Teach:</label>
                    {isEditing ? (
                        <input
                            type="text"
                            name="toTeach"
                            value={lnt.toTeach}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{lnt.toTeach}</p>
                    )}
                </div>
                <div className={styles.profileInfo}>
                    <label>Language:</label>
                     {isEditing ? (
                       <div className={styles.dropdown}>
                        <select
                            name="language"
                            value={lnt.language}
                            onChange={handleChange}
                        >
                            {languages.map((lang) => (
                                <option key={lang} value={lang}>
                                    {lang}
                                </option>
                            ))}
                        </select>
                    </div>
                    ): (
                        <p>{lnt.language}</p>
                    )}
                </div>
                {isEditing ? (
                    <div className={styles.profileActions}>
                        {searchParamsValue? (  
                            <button onClick={handleSaveAndSearch}>Search</button>
                         ) : (
                            <button onClick={handleSaveClick}>Save</button>
                        )}
                        <button onClick={handleCancelClick}>Cancel</button>
                    </div>
                ) : (
                    <div className={styles.profileActions}>
                        <button onClick={handleSearch}>Search</button>
                        <button onClick={handleEditClick}>Edit</button>
                    </div>
                )}
        </div>

        {acceptedOffers.length > 0 &&
            <div className={styles.acceptedOfferSection}>
                <h2>Accepted Offers </h2> 
                <div className={styles.offerList}>
                    {acceptedOffers.map((offer) => 
                        <div key={offer._id} className={styles.offerItem} onClick={handleOfferClick(offer)}>
                            {/* <p>From: {offer.senderId.name|| offer.receiverId.name}</p> */}
                            {offer.senderId === userId ? 
                            <>
                            <p>To Learn: {offer.toLearn.join(', ')}</p>
                            <p>To Teach: {offer.toTeach.join(', ')}</p>
                            </>
                            :
                            <>
                            <p>To Learn: {offer.toTeach.join(', ')}</p>
                            <p>To Teach: {offer.toLearn.join(', ')}</p>
                            </>}
                            <p>Language: {offer.language}</p>
                        </div>
                    )}
                </div>
            </div>
        }

        <div className={styles.offersContainer}>
            {receivedOffers.length > 0 &&
                <div className={styles.receivedOfferSection}>
                <h2>Offers Received</h2> 
                <div className={styles.offerList}>
                    {receivedOffers.map((offer) => 
                        <div key={offer._id} className={styles.offerItem} onClick={handleOfferClick1(offer._id, offer.senderId)}>
                            {/* <p>From: {offer.senderId.name}</p> */}
                            <i>(They want)</i>
                            <p>To Learn: {offer.toLearn.join(', ')}</p>
                            <p>To Teach: {offer.toTeach.join(', ')}</p>
                            <p>Language: {offer.language}</p>
                        </div>
                    )}
                </div>
            </div>}
        {sentOffers.length > 0 &&
            <div className={styles.sentOfferSection}>
                <h2>Offers Sent</h2>
                <div className={styles.offerList}>
                   {sentOffers.map((offer) => 
                        <div key={offer._id} className={styles.offerItem} onClick={handleOfferClick2(offer._id, offer.receiverId)}>
                            {/* <p>From: {offer.senderId.name}</p> */}
                            <i>(I want)</i>
                            <p>To Learn: {offer.toLearn.join(', ')}</p>
                            <p>To Teach: {offer.toTeach.join(', ')}</p>
                            <p>Language: {offer.language}</p>
                        </div>
                    )}
                </div>
            </div>
        }
        </div>
    </div>
)}
export default GuestLearnTeach;